/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface UboDeclarationEventTimelinePayload
 */
export interface UboDeclarationEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationEventTimelinePayload
     */
    externalUboDeclarationId: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationEventTimelinePayload
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationEventTimelinePayload
     */
    message?: string;
}

/**
 * Check if a given object implements the UboDeclarationEventTimelinePayload interface.
 */
export function instanceOfUboDeclarationEventTimelinePayload(value: object): value is UboDeclarationEventTimelinePayload {
    if (!('externalUboDeclarationId' in value) || value['externalUboDeclarationId'] === undefined) return false;
    return true;
}

export function UboDeclarationEventTimelinePayloadFromJSON(json: any): UboDeclarationEventTimelinePayload {
    return UboDeclarationEventTimelinePayloadFromJSONTyped(json, false);
}

export function UboDeclarationEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'externalUboDeclarationId': json['externalUboDeclarationId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function UboDeclarationEventTimelinePayloadToJSON(value?: UboDeclarationEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'externalUboDeclarationId': value['externalUboDeclarationId'],
        'reason': value['reason'],
        'message': value['message'],
    };
}

